// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"332":"3e250105","453":"a00e8433","633":"9c8ca4c9"}[chunkId] + ".chunk.js";
};